module.exports = __webpack_public_path__ + "img/pr-3.23083b4b.png";